module.exports = __webpack_public_path__ + "img/cass1.c46b5753.jpg";